import { render, staticRenderFns } from "./BetriebsergebnisGesamtJahre.vue?vue&type=template&id=392578a4&"
import script from "./BetriebsergebnisGesamtJahre.vue?vue&type=script&lang=ts&"
export * from "./BetriebsergebnisGesamtJahre.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports